export default "__VITE_ASSET__35fa77e3__"